import styled, { css } from 'styled-components'

interface TableCardRowProps {
    row: number
}

export const TableCardRow = styled.div<TableCardRowProps>`
    flex: 1;

    ${props =>
        props.row === 1 &&
        css`
            text-align: center;
        `}

    ${props =>
        props.row === 2 &&
        css`
            text-align: right;
        `}
`
